<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
</script>

<template>
  <div class="app-container">
    <header class="app-header">
      <div class="header-content">
        <h1 class="app-title">我的人工智能总览</h1>
        <nav class="app-nav">
          <RouterLink to="/" class="nav-link">首页</RouterLink>
          <RouterLink to="/about" class="nav-link">关于</RouterLink>
        </nav>
      </div>
    </header>

    <main class="app-main">
      <!-- Use keep-alive for route components that should be cached -->
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component 
            :is="Component" 
            v-if="route.meta.keepAlive" 
            :key="route.path"
          />
        </keep-alive>
        <component 
          :is="Component" 
          v-if="!route.meta.keepAlive"
          :key="route.path"
        />
      </router-view>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background-color: $primary-bg;
  color: $text-primary;
  display: flex;
  flex-direction: column;
}

.app-header {
  padding: $spacing-md $spacing-lg;
  border-bottom: 1px solid $border-light;
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  .app-title {
    font-size: 1.5rem;
    font-weight: 600;
  }
}

.app-nav {
  display: flex;
  gap: $spacing-md;
  
  .nav-link {
    color: $text-secondary;
    text-decoration: none;
    padding: $spacing-xs $spacing-md;
    border-radius: $border-radius-md;
    transition: all 0.2s ease;
    
    &:hover {
      color: $text-primary;
      background-color: rgba(255, 255, 255, 0.05);
    }
    
    &.router-link-active {
      color: $text-primary;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

.app-main {
  flex: 1;
  padding: $spacing-lg;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

@media (max-width: $mobile) {
  .app-header {
    padding: $spacing-sm;
    
    .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: $spacing-sm;
    }
  }
  
  .app-main {
    padding: $spacing-md;
  }
}
</style>
